import React, {useState, useEffect} from "react";
import Table from "../Table/Table";
import {useGetPlantsByClient} from "../../hooks/Administrative/useGetPlantsByClient";
import './PlantsView.css';
import {useUpdatePlantById} from "../../hooks/Administrative/useUpdatePlantById";
import {Bounce, toast} from "react-toastify";
import {useCreatePlant} from "../../hooks/Administrative/useCreatePlant";

const columns = ['NOMBRE', 'CÓDIGO ÚNICO'];

const PlantsView = ({onBack, uniqueCode}: { onBack: () => void; uniqueCode: string }) => {

    const {
        plants,
        totalPages,
        isLoading,
        page,
        setPage,
        updatePlantLocally,
        addPlantLocally
    } = useGetPlantsByClient(uniqueCode);

    const [addPlant, setAddPlant] = useState(false);
    const [seePlantInfo, setSeePlantInfo] = useState(false);
    const [editDisabled, setEditDisabled] = useState(true);
    const [selectedPlant, setSelectedPlant] = useState<any>(null);
    const [editValues, setEditValues] = useState({
        name: '',
        description: '',
        address: '',
        uniqueCode: uniqueCode,
        id: '',
        location: '',
    });

    const [transformedPlants, setTransformedPlants] = useState<any[]>([]);
    const {updatePlant, loadingUpdate} = useUpdatePlantById();
    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

    const [plantName, setPlantName] = useState("");
    const [plantAddress, setPlantAddress] = useState("");
    const [plantDescription, setPlantDescription] = useState("");
    const [plantUniqueCode, setPlantUniqueCode] = useState("");
    const [plantLocation, setPlantLocation] = useState("");

    const {createNewPlant, savingNewPlant} = useCreatePlant();

    useEffect(() => {
        const newTransformedPlants = plants.map((item: any) => ({
            NOMBRE: item.name,
            'CÓDIGO ÚNICO': item.uniqueCode,
        }));
        setTransformedPlants(newTransformedPlants);
    }, [plants]);

    useEffect(() => {
        if (selectedPlant) {
            setEditValues({
                name: selectedPlant.name || '',
                description: selectedPlant.description || '',
                address: selectedPlant.address || '',
                uniqueCode: selectedPlant.uniqueCode || '',
                id: selectedPlant.id,
                location: selectedPlant.location || '',
            });
        }
    }, [selectedPlant]);

    useEffect(() => {
        const isDisabled = !plantName || !plantAddress || !plantUniqueCode;
        setIsConfirmDisabled(isDisabled);
    }, [plantName, plantAddress, plantUniqueCode]);

    const handleAddPlant = () => {
        setEditDisabled(true);
        setSeePlantInfo(false);
        setAddPlant(true);
    };

    const handleNewPlant = (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateField(plantName, /^.{1,80}$/, "El nombre de la planta no puede exceder los 80 caracteres ni estar vacío.")) return;
        if (!validateField(plantAddress, /^.{1,200}$/, "La dirección de la planta no puede exceder los 200 caracteres ni estar vacío.")) return;
        if (!validateField(plantDescription, /^.{0,200}$/, "La descripción de la planta no puede exceder los 100 caracteres")) return;
        if (!validateField(plantUniqueCode, /^[a-zA-Z0-9_]{5,10}$/, "El código único solo puede contener letras, números y guión bajo (_). Tiene que tener entre 5 y 10 caracteres.")) return;

        const newPlantDto = {
            name: plantName,
            description: plantDescription,
            address: plantAddress,
            uniqueCode: plantUniqueCode,
            clientUniqueCode: uniqueCode,
            location: plantLocation
        }

        createNewPlant(newPlantDto)
            .then((response) => {
                toast.success('¡Planta creada correctamente!', {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
                addPlantLocally(newPlantDto)
                resetForm()
            })
            .catch((error: any) => {
                toast.error(error.message, {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
            });
    }

    const resetForm = () => {
        setPlantName("")
        setPlantAddress("")
        setPlantDescription("")
        setPlantUniqueCode("")
        setPlantLocation("")
    }


    const handleSeePlantInfo = (row: Record<string, any>) => {
        setEditDisabled(true);
        const plant = plants.find(item => item.uniqueCode === row['CÓDIGO ÚNICO']);
        setSelectedPlant(plant);
        setAddPlant(false);
        setSeePlantInfo(true);
    };

    const validateField = (field: any, regex: any, errorMessage: any) => {
        if (!regex.test(field)) {
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return false;
        }
        return true;
    };

    const handleSave = () => {

        if (!validateField(editValues.name, /^.{1,80}$/, "El nombre de la planta no puede exceder los 80 caracteres ni estar vacío.")) return;
        if (!validateField(editValues.address, /^.{1,200}$/, "La dirección de la planta no puede exceder los 200 caracteres ni estar vacío.")) return;
        if (!validateField(editValues.description, /^.{0,200}$/, "La descripción de la planta no puede exceder los 100 caracteres")) return;
        updatePlant(editValues).then(() => {
            toast.success('¡Planta actualizada correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });

            setTransformedPlants(prevState =>
                prevState.map(plant =>
                    plant['CÓDIGO ÚNICO'] === editValues.uniqueCode
                        ? {...plant, NOMBRE: editValues.name}
                        : plant
                )
            );
            updatePlantLocally(editValues.uniqueCode, editValues);
        }).catch((error: any) => {
            toast.error(error.message, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        });
        setEditDisabled(true);
    };

    return (
        <div className="plants-view-container">
            <div className="plants-view-left">
                <div className="plants-info-view-header">
                    <button onClick={onBack}>REGRESAR</button>
                    <div className="plants-info-view-header-title">
                        <p>PLANTAS</p>
                    </div>
                    <span className="material-icons-outlined icon-unselected" onClick={handleAddPlant}>
                        add_box
                    </span>
                </div>
                {isLoading ?
                    (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">Obteniendo información...</div>
                        </div>
                    ) : (
                        <div className="plants-table-view">
                            <Table
                                columns={columns}
                                data={transformedPlants}
                            totalPages={totalPages}
                            currentPage={page}
                            setCurrentPage={setPage}
                            onRowClick={handleSeePlantInfo}
                        />
                    </div>
                    )}
            </div>
            <div className="plant-view-actions">
                {addPlant && (
                    <div className="plants-view-actions-wrapper">
                        {savingNewPlant ?
                            (
                                <div className="loading-overlay-for-plant-view">
                                    <div className="spinner"></div>
                                    <div className="loading-message">Guardando</div>
                                </div>
                            ) :
                            (
                                <div>
                                    <div className="plants-info-view-header">
                                        <div className="plants-info-view-header-title">
                                            <p>AÑADIR PLANTA</p>
                                        </div>
                                    </div>
                                    <form className="add-plant-form" onSubmit={handleNewPlant}>
                                        <div className="form-item">
                                            <label htmlFor="name">NOMBRE *</label>
                                            <input
                                                id="name"
                                                value={plantName}
                                                onChange={(e) => setPlantName(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="name">DIRECCIÓN *</label>
                                            <input
                                                id="name"
                                                value={plantAddress}
                                                onChange={(e) => setPlantAddress(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="name">DESCRIPCIÓN</label>
                                            <input
                                                id="name"
                                                value={plantDescription}
                                                onChange={(e) => setPlantDescription(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="name">CÓDIGO ÚNICO * </label>
                                            <input
                                                id="name"
                                                value={plantUniqueCode}
                                                onChange={(e) => setPlantUniqueCode(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="name">UBICACIÓN </label>
                                            <input
                                                id="name"
                                                value={plantLocation}
                                                onChange={(e) => setPlantLocation(e.target.value)}
                                            />
                                        </div>
                                        <div className="bottom">
                                            <p>* Campos obligatorios</p>
                                            <div className="buttons">
                                                <button type="button" className="cancel" onClick={resetForm}>
                                                    Cancelar
                                                </button>
                                                <button
                                                    type="submit"
                                                    className={`confirm ${isConfirmDisabled ? 'disabled' : ''}`}
                                                    disabled={isConfirmDisabled}
                                                >
                                                    Guardar
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            )
                        }

                    </div>
                )}
                {seePlantInfo && (
                    <div className="plants-view-actions-wrapper">
                        {loadingUpdate ? (
                            <div className="loading-overlay-for-plant-view">
                                <div className="spinner"></div>
                                <div className="loading-message">Guardando cambios</div>
                            </div>
                        ) : (
                            <div>
                                <div className="plants-info-view-header">
                                    <div className="plants-info-view-header-title">
                                        <p>PLANTA</p>
                                    </div>
                                    <span
                                        className={`material-icons-outlined icon-unselected ${
                                            !editDisabled ? "active-edit" : ""
                                        }`}
                                        onClick={() => setEditDisabled(!editDisabled)}
                                    >
                                edit
                            </span>
                                </div>
                                <div className="plants-info-fields">
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">CLAVE DE PLANTA</div>
                                        <div className="value-label">{selectedPlant?.uniqueCode}</div>
                                    </div>
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">NOMBRE</div>
                                        <input
                                            className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                            type="text"
                                            value={editValues.name}
                                            onChange={(e) =>
                                                setEditValues({...editValues, name: e.target.value})
                                            }
                                            disabled={editDisabled}
                                        />
                                    </div>
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">DESCRIPCIÓN</div>
                                        <input
                                            className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                            type="text"
                                            value={editValues.description}
                                            onChange={(e) =>
                                                setEditValues({...editValues, description: e.target.value})
                                            }
                                            disabled={editDisabled}
                                        />
                                    </div>
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">DIRECCIÓN</div>
                                        <input
                                            className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                            type="text"
                                            value={editValues.address}
                                            onChange={(e) =>
                                                setEditValues({...editValues, address: e.target.value})
                                            }
                                            disabled={editDisabled}
                                        />
                                    </div>
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">UBICACIÓN</div>
                                        <input
                                            className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                            type="text"
                                            value={editValues.location}
                                            onChange={(e) =>
                                                setEditValues({...editValues, location: e.target.value})
                                            }
                                            disabled={editDisabled}
                                        />
                                    </div>
                                    {!editDisabled && (
                                        <div className="bottom-buttons">
                                            <button type="submit" className="confirm" onClick={handleSave}>
                                                Guardar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PlantsView;
